(function () {
  if (window.PWMoneyNLLoaded) return;
  window.PWMoneyNLLoaded = true;

  var EURO_PATTERN = /€\s*((?:\d{1,3}(?:[.,]\d{3})+|\d+)(?:[.,]\d{1,2}|,-)?)/g;
  var scheduled = false;

  function parseMoneyToken(token) {
    var value = String(token || '').replace(/\s+/g, '');
    if (!value) return null;

    if (/,-$/.test(value)) value = value.slice(0, -2);

    var comma = value.lastIndexOf(',');
    var dot = value.lastIndexOf('.');
    var decimalSeparator = '';

    if (comma >= 0 && dot >= 0) {
      decimalSeparator = comma > dot ? ',' : '.';
    } else if (comma >= 0) {
      var commaDecimals = value.length - comma - 1;
      if (commaDecimals > 0 && commaDecimals <= 2) decimalSeparator = ',';
    } else if (dot >= 0) {
      var dotDecimals = value.length - dot - 1;
      if (dotDecimals > 0 && dotDecimals <= 2) decimalSeparator = '.';
    }

    var integerPart;
    var fractionPart = '';

    if (decimalSeparator) {
      var decimalIndex = value.lastIndexOf(decimalSeparator);
      integerPart = value.slice(0, decimalIndex).replace(/[.,]/g, '');
      fractionPart = value.slice(decimalIndex + 1).replace(/\D/g, '').slice(0, 2);
    } else {
      integerPart = value.replace(/[.,]/g, '');
    }

    if (!/^\d+$/.test(integerPart || '')) return null;
    if (fractionPart && !/^\d+$/.test(fractionPart)) return null;

    while (fractionPart.length < 2) fractionPart += '0';
    if (!fractionPart) fractionPart = '00';

    return (Number(integerPart) * 100) + Number(fractionPart);
  }

  function groupThousands(value) {
    return String(value);
  }

  function formatCents(cents) {
    if (cents === null || !isFinite(cents)) return '';

    var rounded = Math.round(Number(cents));
    var euros = Math.floor(rounded / 100);
    var remainder = rounded % 100;
    var whole = groupThousands(euros);

    if (remainder === 0) return '€ ' + whole + ',-';
    return '€ ' + whole + ',' + (remainder < 10 ? '0' : '') + remainder;
  }

  function formatCardCents(cents) {
    if (cents === null || !isFinite(cents)) return '';

    var rounded = Math.round(Number(cents));
    var euros = Math.floor(rounded / 100);
    var remainder = rounded % 100;
    var whole = String(euros);

    if (remainder === 0) return '€ ' + whole + ',-';
    return '€ ' + whole + ',' + (remainder < 10 ? '0' : '') + remainder;
  }

  function formatEuroText(text) {
    return String(text || '').replace(EURO_PATTERN, function (match, token) {
      var cents = parseMoneyToken(token);
      var formatted = formatCents(cents);
      return formatted || match;
    });
  }

  function formatMoneyElement(element) {
    if (!element || element.nodeType !== 1) return;

    var rawCents = element.getAttribute('data-pw-money-cents');
    if (rawCents === null || rawCents === '') return;

    var cents = Number(rawCents);
    if (!isFinite(cents)) return;

    var formatted = formatCardCents(cents);
    if (formatted && element.textContent !== formatted) element.textContent = formatted;
  }

  function formatMoneyElements(root) {
    if (!root) return;

    var elements = [];
    if (root.nodeType === 1 && root.hasAttribute && root.hasAttribute('data-pw-money-cents')) {
      elements.push(root);
    }

    if (root.querySelectorAll) {
      var found = root.querySelectorAll('[data-pw-money-cents]');
      for (var i = 0; i < found.length; i += 1) elements.push(found[i]);
    }

    for (var j = 0; j < elements.length; j += 1) formatMoneyElement(elements[j]);
  }

  function shouldSkipTextNode(node) {
    var parent = node && node.parentNode;
    while (parent && parent !== document.body) {
      if (parent.nodeType === 1) {
        if (parent.hasAttribute && parent.hasAttribute('data-pw-money-cents')) return true;
        var tag = parent.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA' || tag === 'PRE' || tag === 'CODE') return true;
      }
      parent = parent.parentNode;
    }
    return false;
  }

  function formatTextNode(node) {
    if (!node || node.nodeType !== 3 || shouldSkipTextNode(node)) return;

    var current = node.nodeValue || '';
    if (current.indexOf('€') === -1) return;

    var formatted = formatEuroText(current);
    if (formatted !== current) node.nodeValue = formatted;
  }

  function formatRoot(root) {
    if (!root) return;

    formatMoneyElements(root);

    if (root.nodeType === 3) {
      formatTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 9 && root.nodeType !== 11) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i += 1) formatTextNode(nodes[i]);
  }

  function run() {
    scheduled = false;
    formatRoot(document.body);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(run, 0);
  }

  function start() {
    run();

    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        var needsRun = false;
        for (var i = 0; i < records.length && !needsRun; i += 1) {
          var record = records[i];
          if (record.type === 'attributes') {
            needsRun = true;
            continue;
          }
          if (record.type === 'characterData') {
            if ((record.target.nodeValue || '').indexOf('€') !== -1) needsRun = true;
            continue;
          }
          for (var j = 0; j < record.addedNodes.length; j += 1) {
            var node = record.addedNodes[j];
            if (node.nodeType === 3 && (node.nodeValue || '').indexOf('€') !== -1) {
              needsRun = true;
              break;
            }
            if (node.nodeType === 1) {
              needsRun = true;
              break;
            }
          }
        }
        if (needsRun) schedule();
      }).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-pw-money-cents']
      });
    }

    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  window.PWFormatMoneyNL = function (cents) {
    return formatCents(Number(cents));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
